/**
 * Googleマップ
 */
export default class Gmap {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'Gmap';
    this.office = {lat: 35.6450031, lng: 139.704509};
    this.map = null;
    this.marker = null;
    this.size = {
      h: 86 * 0.75,
      w: 62 * 0.75
    };
    this.elMap = document.getElementById('gmap');

    if (this.elMap) {
      this.init();
    }
  }

  /**
   * 初期化
   */
  init() {

    const key = 'AIzaSyCng-ZrIcUf8u1acADZ5JjAy2mH4-emGUQ';
    //const key = 'AIzaSyAhINnoKIuat8DFyMWhuv3rxmIfwAp6tCU';

    // googleマップのscriptタグ生成
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initGmap`;
    script.setAttribute('async', 'async');
    script.setAttribute('defer', 'defer');
    document.getElementsByTagName('head')[0].appendChild(script);

    // コールバック
    window.initGmap = this.initGmap.bind(this);
  }

  /**
   * Googleマップ設定（コールバック）
   */
  initGmap() {
    const customMapTypeId = 'custom_style';
    const customMapType = new google.maps.StyledMapType([{
      featureType: "all",
      elementType: "all",
      stylers: [{saturation: "-100"}, {lightness: "30"}, {weight: "0"}, {visibility: "simplified"}, {hue: "#0090ff"}]
    }], {name: "Styled Map"});

    // The map, centered at office
    this.map = new google.maps.Map(
      this.elMap, {
        zoom: 18,
        center: this.office,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        mapTypeControlOptions: {
          mapTypeIds: [google.maps.MapTypeId.ROADMAP, customMapTypeId]
        },
        mapTypeId: customMapTypeId,
        styles: []
      });

    this.setMarker(true);

    this.map.mapTypes.set(customMapTypeId, customMapType);
    this.map.setMapTypeId(customMapTypeId);

    google.maps.event.addDomListener(window, "resize", this.resize.bind(this));
  }

  setMarker(isDrop) {
    let makerSize = {};
    makerSize = this.size;

    /*if (AnyStore.setDevice() === 'sp') {
      makerSize.h = (this.size.h / 750) * AnyStore.getWindowWidth();
      makerSize.w = (this.size.w / 750) * AnyStore.getWindowWidth();
    } else {
      makerSize = this.size;
    }*/

    if (this.marker) this.marker.setMap(null);

    // The marker, positioned at office
    this.marker = new google.maps.Marker({
      position: this.office,
      map: this.map,
      icon: {
        url: '/manage/wp-content/themes/pics/assets/img/common/marker-map.svg',
        scaledSize: new google.maps.Size(makerSize.w, makerSize.h),
      },
      title: '株式会社ピクス / P.I.C.S. Co., Ltd.',
      animation: isDrop ? google.maps.Animation.DROP : null,
    });
  }

  /**
   * リサイズ
   */
  resize() {
    this.setMarker(false);
  }

  /**
   * MatchMedia（メディアクエリ）による判別
   */
  getMatchMedia() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  /**
   * 現在のデバイスを判別（ブラウザ幅）
   */
  setDevice() {
    return this.getMatchMedia() ? 'sp' : 'pc';
  }
}
